
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.631 1.391a.784.784 0 00.224.557l6.051 6.184a.796.796 0 00.59.265.823.823 0 00.597-.257l6.043-6.184a.777.777 0 00.233-.565.783.783 0 00-.789-.788.827.827 0 00-.564.232L7.496 6.48 1.984.835A.826.826 0 001.42.603a.778.778 0 00-.789.788z"}})])
          )
        }
      }
    